import { css } from '@/styled-system/css';

export const tooltipContentStyles = css.raw({
  maxInlineSize: '360px',
  color: 'Tooltip.neutral.text',
  textStyle: 'body',
  backgroundColor: 'Tooltip.neutral.bg',
  borderRadius: 'Tooltip',
  paddingInline: {
    base: 'Tooltip.mWeb.padding.horz',
    lg: 'Tooltip.desktop.padding.horz',
  },
  paddingBlock: {
    base: 'Tooltip.mWeb.padding.vert',
    lg: 'Tooltip.desktop.padding.vert',
  },
  filter: 'drop-shadow({shadows.Tooltip})',
  willChange: 'filter',
});

export const tooltipContentPositionerStyles = css.raw({
  zIndex: 'tooltip',
});
